<cx-navigation-ui
  *ngIf="data$ | async as data"
  [node]="node$ | async"
  [ngClass]="data.properties?.styleClass ?? ''"
  [wrapAfter]="+(data.properties?.wrapAfter ?? '')"
  [resetMenuOnClose]="data.properties?.resetMenuOnClose"
  [navAriaLabel]="'navigation.categoryNavLabel' | cxTranslate"
></cx-navigation-ui>
